export default {
	10001: 'INVALID_ITEM_NUMBER'
};
